











import {ChartDataTemplate, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import appConfig from '@/config'
import {executeQuery} from "@/data/repos/query"
import {defineComponent, reactive} from "@vue/composition-api"
import {getLocationCaption} from "@/data/sources/appraisal"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"

export function config(): WidgetDefinition {
    return {
      ...WConfTpl.ScrollLine2D(),
      widget: "CeilingHeights",
      title: "Ceiling Heights",
      params: {
        locationId: {...WParamTpl.locationId(), _order: 1},
      },
    }
  }

  function getChartDataConfig() {
    return reactive({
          ...ChartDataTemplate(),
          xAxisName: "Rooms",
          yAxisName: "Ceiling height (m)",
          showLabels: "1",
          numVisiblePlot: "32",
          rotateLabels: "1",
          animation: "0",
          bgColor: "#FFFFFF",
        },
    )
  }

  const chartDSTemplate = () => {
    return {categories: [], dataset: []}
  }

  export default defineComponent({
    props: {
      config: Object,
    },
    components: {FusionChartWidget},
    setup(props, context) {
      context.emit("config-update", config())

      async function dataFetcher(params: any) {
        const items = await executeQuery("idr", "eric.ceilingHeights", {
          locationId: params.locationId.value,
        })
        // {label: v.roomName, value: v.HeightToCeiling}
        // chartDataConfig.xAxisName = "Rooms (" + len[0] + ")"
        // console.info("CeilingHeights:", items)
        // const average = items.reduce((sum, item) => sum + (isNaN(item.HeightToCeiling) ? 0: item.HeightToCeiling), 0) / items.length
        // console.info("average:", average)
        return {
          categories: [
            {
              category: items.map(item => {
                return {
                  label: item.roomName
                }
              })
            }
          ],
          dataset: [
            {
              data: items.map(item => {
                return {
                  value: item.HeightToCeiling
                }
              })
            }
          ],
        }
      }

      function dataplotClickCallback(label: string, val: any) {
        const iprUrl = appConfig.IPR_BASE_URL
        const locationId = props.config.params.locationId.value
        window.open(iprUrl + `/pages/eric_site.asp?id=${locationId}&return=site_details.aspx?id=${locationId}`)
        console.log("chartClickCallback", label, val)
      }

      async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
        if (config) {
          chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
        }
      }

      return {dataFetcher, chartDSTemplate, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })

